export default "__VITE_PUBLIC_ASSET__4b46ab23__"